import React from 'react';
import { Scissors } from 'lucide-react';

const items = [
  'Coupe Homme',
  'Dégradé Américain',
  'Taille de Barbe',
  'Rasage Traditionnel',
  'Contour au Rasoir',
  'Soin à la Serviette Chaude',
  'Coupe Enfant',
  'Design & Motifs',
];

const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section className="relative bg-[#0a0a0a] border-y border-[#c9a961]/15 py-6 overflow-hidden">
      <div className="flex marquee-track whitespace-nowrap">
        {row.map((it, i) => (
          <div key={i} className="flex items-center gap-8 px-8 shrink-0">
            <Scissors className="w-4 h-4 text-[#c9a961]" />
            <span className="font-display italic text-2xl md:text-3xl text-[#f5efe4]/90">
              {it}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
